{"id":"ProductDetail.Info.Alergens","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.Alergens","options":"options:*"}]}}}